import React, { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import '../Styles/GlobalStyling.css'
import { FaCheckCircle, FaFire, FaBars, FaTimes} from 'react-icons/fa'
import '../Styles/Mentor.css'
import '../Styles/navbar.css'
import logo from '../images/logo.svg'
import discovery from '../images/discovery.svg'
import history from '../images/019-history.png'
import chem from '../images/020-chemistry.png'
import phy from '../images/021-atom.png'
import learn from '../images/e-learning colored.svg'
import student from '../images/student.png'
import mentor from '../images/mentor.png'
import conversation from '../images/conversation.png'
import Accordion from '../Acordion/Accordion'
import Footer from '../sections/Footer'
import Question from '../sections/Question'


const Mentor = () => {
    const [clicked, setClicked] = useState(false)

    const HandleClick = () => setClicked(!clicked)
    return (
        <>
                    {/* Navigation bar //////// */}
            <div className="navbar">
            
            <NavLink to="/" className="nav-logo">
                <img src={logo} alt="" className="logo" />
                <h3 className="logo-text">
                    WorkMate
                </h3>
            </NavLink>

            <div className="menu-icon" onClick={HandleClick}>
                {clicked ? <FaTimes/> : <FaBars/>}
            </div>

            <ul className={clicked ? 'menu active' : 'menu'}>
                <li className="nav-item" onClick={HandleClick}>
                    Link
                </li>
                <li className="nav-item" onClick={HandleClick}>
                    Link
                </li>
                <li className="nav-item" onClick={HandleClick}>
                   <NavLink to='/Mentors'>
                       Mentors
                   </NavLink>
                </li>
                <li className="nav-item" onClick={HandleClick}>
                <NavLink to='/Dashboard'>
                       Dashboard
                   </NavLink>
                </li>
                <li className="nav-item mobile" onClick={HandleClick}>
                    <Link to='/SignUp'>
                        Join Us
                    </Link>
                </li>
            </ul>
            <Link to='/SignUp' className="cta mobile">
                Join Us
            </Link>
        </div>

        {/* end of navbar////// */}



        <div className='tutor-container container'>
                <div className="hero">
                    <div className="d-flex">
                        <div className="flex-1">
                                <h3 className="heading">
                                        Instant online tutoring
                                </h3> 
                                <p className="text">
                                    Right now, you can get <strong>1 on 1 math help</strong> in real time.
                                    <br />
                                    Our online math tutors will guide you to a good answer and a netter understanding, <strong>Anytime 24/7</strong>
                                </p>
                        </div>
                        <div className="flex-2">
                            <div className="image">
                                <img src={learn} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <section className="sec-2">
                    <h4 className="header">
                        Dive deeper. Understand more.
                    </h4>

                    <div className="cards d-flex">
                        <div className="card">
                            <img src={learn} alt="" className="card-image" />
                            <h4 className="card-head">
                                Clear away doubts in real time
                            </h4>
                            <p className="card-body">
                                with text chat and drawings, you get the clarity you need to truly understand
                            </p>
                        </div>
                        <div className="card">
                        <img src={learn} alt="" className="card-image" />
                            <h4 className="card-head">
                                Clear away doubts in real time
                            </h4>
                            <p className="card-body">
                                with text chat and drawings, you get the clarity you need to truly understand
                            </p>
                        </div>
                        <div className="card">
                        <img src={learn} alt="" className="card-image" />
                            <h4 className="card-head">
                                Clear away doubts in real time
                            </h4>
                            <p className="card-body">
                                with text chat and drawings, you get the clarity you need to truly understand
                            </p>
                        </div>
                    </div>
                    <div className="sec-2-b">
                        <div className="flex-1">
                            <h3 className="head">
                                YOUR ALLY IN THE NUMBERS GAME
                            </h3>
                            <ul className="marked">
                                <li className="marked-item">
                                    <FaFire className='icon'/>
                                    Learn without limits on question or time.
                                </li>
                                <li className="marked-item">
                                    <FaFire className='icon'/>
                                    Level up the most sought-after skills.
                                </li>
                                <li className="marked-item">
                                    <FaFire className='icon'/>
                                    Finish your homework with better results.
                                </li>
                            </ul>
                        </div>
                        <div className="flex-2">
                            <div className="boxed-cards d-flex" >
                                <div className="boxed-card">
                                    <img src={history} alt="" />
                                    <h4 className="boxed-card-head">
                                        History
                                    </h4>
                                    <p className="boxed-card-highlited available">
                                        Available
                                    </p>
                                </div>
                                <div className="boxed-card">
                                    <img src={chem} alt="" />
                                    <h4 className="boxed-card-head">
                                        Chemistry
                                    </h4>
                                    <p className="boxed-card-highlited unavailable">
                                        Unavailable
                                    </p>
                                </div>
                                <div className="boxed-card">
                                    <img src={phy} alt="" />
                                    <h4 className="boxed-card-head">
                                        Physics
                                    </h4>
                                    <p className="boxed-card-highlited unavailable">
                                        Unavailable
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="sec-3">
                    <div className="d-flex">
                        <div className="flex-1">
                            <h3 className="heading">
                                <span className="colored">
                                    GO BEYOND
                                </span>
                                <br />
                                Workmate Tutors takes you a step beyond Brainly Plus. You get the full range of Workmate benefits.
                            </h3>

                            <ul className="marked-2">
                                <li className="marked-item">
                                    <FaCheckCircle className='icon'/>
                                    Unlimited instant tutoring to keep you unstuck.
                                </li>
                                <li className="marked-item">
                                <FaCheckCircle className='icon'/>
                                    No ads or interuptions so you never have to wait.
                                </li>
                                <li className="marked-item">
                                <FaCheckCircle className='icon'/>
                                    Finish your homework with better results.
                                </li>
                                <li className="marked-item">
                                <FaCheckCircle className='icon'/>
                                    Finish your homework with better results.
                                </li>
                            </ul>
                        </div>
                        <div className="flex-2">
                            <div className="image">
                                <img src={discovery} alt="" />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="sec-4">
                    <h4 className="header">
                        Dive deeper. Understand more.
                    </h4>

                    <div className="d-flex steps">
                        <div className="flex-1">
                            <h3 className="heading">
                                <span className="colored">
                                STEP 1
                                </span>
                                <br />
                                ASK AND CONNECT
                            </h3>

                            <p className="text">
                                Enter your question and get paired with a professional tutor in seconds.
                            </p>
                        </div>
                        <div className="flex-2">
                            <div className="image">
                                <img src={student} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="r-flex steps">
                        <div className="flex-1">
                            <h3 className="heading">
                                <span className="colored">
                                STEP 2
                                </span>
                                <br />
                                GET 1 ON 1 HELP
                            </h3>

                            <p className="text">
                                use the chat, text editor and drawings to learn live with your mentor.
                            </p>
                        </div>
                        <div className="flex-2">
                            <div className="image">
                            <img src={mentor} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex steps">
                        <div className="flex-1">
                            <h3 className="heading">
                                <span className="colored">
                                STEP 3
                                </span>
                                <br />
                                    TALK IT OUT
                            </h3>

                            <p className="text">
                            Ask as many followup questions as you need to untill you fully grasp the answer. <br />
                            That's learning for real!
                            </p>
                        </div>
                        <div className="flex-2">
                            <div className="image">
                            <img src={conversation} alt="" />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="sec-5">
                    <h4 className="header">
                        Dive deeper. Understand more.
                    </h4>


                    <div className="accordion-container">
                        <Accordion/>
                    </div>
                </section>
               
            </div> 
            <Question/>
            <Footer/>

        </>
        
    )
}

export default Mentor
